import Generator from '../../../../Generator'
import Types from '../../../../../actions/Types'

export default Generator.node({
  baseType: Types.CTRL_PRODS,
  nodeType: Generator.NODETYPE.PUT
})



// WEBPACK FOOTER //
// ./src/reducers/root/entities/controls/product/put.js